var _path, _path2, _circle;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCamera(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "       M6 7       H18       A3 3 0 0 1 21 10       V17       A3 3 0 0 1 18 20       H6       A3 3 0 0 1 3 17       V10       A3 3 0 0 1 6 7       Z       M12 11.2       a3.8 3.8 0 1 0 0 7.6       a3.8 3.8 0 1 0 0 -7.6       Z       M7.2 9.8       a1 1 0 1 0 0 2       a1 1 0 1 0 0 -2       Z     ",
    fill: "#3945B3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "       M9 5.2       H15       A1.6 1.6 0 0 1 16.6 6.8       V7.2       H7.4       V6.8       A1.6 1.6 0 0 1 9 5.2       Z     ",
    fill: "#3945B3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12,
    cy: 15,
    r: 2.05,
    fill: "#3945B3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCamera);
export default __webpack_public_path__ + "static/media/icon_camera.d7e7026c31fd724b9401cb41818e90f9.svg";
export { ForwardRef as ReactComponent };